import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { GovernmentAllocationSummaryData } from '@/features/governmentAllocations/types/governmentAllocationSummary.type'
import { useQuery } from '@tanstack/react-query'

type UseGovernmentAllocationSummaryProps<T> = {
  governmentAllocationId: string
  mapper?: (data: any) => T
}

export const useGovernmentAllocationSummary = <T,>({
  governmentAllocationId,
  mapper = Mapper.default<T>(),
}: UseGovernmentAllocationSummaryProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse(), ...rest } = useQuery({
    queryKey: ['governmentAllocationSummary', governmentAllocationId],
    queryFn: () =>
      privateAxios.get(`/billing/government_allocations/${governmentAllocationId}/summary_of_consumed_and_distributed`),
    select: (data: { data: { data: GovernmentAllocationSummaryData; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
  })

  return {
    data,
    meta,
    ...rest,
  }
}
